import React from 'react';
import css from './card-details.module.scss';
import Complaint from 'src/pages/complaint/complaint';
import { ContactCard } from 'src/types';
import ContactIcon from '../contact-icons';
import { ComplaintEntityType } from 'src/constants/complaint-entity-type';

interface CardProps {
  card: ContactCard;
}

export default function ContactCardDetails({ card }: Readonly<CardProps>) {
  const wrapper = (
    complaint: JSX.Element,
    onMouseEnter: React.MouseEventHandler<HTMLDivElement> | undefined,
    onMouseLeave: React.MouseEventHandler<HTMLDivElement> | undefined
  ) => (
    <div className={css.card} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <p className={css.title}>{card.title}</p>
      {complaint}
      <div className={css.contactWrapper}>
        {card.contacts.map((contact) => (
          <div className={css.contact} key={contact.id}>
            <p className={css.name}>{contact.name.toUpperCase()}</p>
            <div className={css.value}>
              <p>{contact.value}</p>
              <ContactIcon contact={contact} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
  return (
    <Complaint
      key={card.id}
      entityId={card.id}
      targetTitle={card.title}
      entityType={ComplaintEntityType.CONTACTS}
      alignRight={true}
      wrapper={wrapper}
    />
  );
}
